module.exports = __webpack_public_path__ + "media/images/haircut/alexandre@3x-33d3eeb89771ec206d6df15d46e69bda.jpg";